import axios, { CancelTokenSource } from 'axios';
import { ResourceGroupDto, ResourceGroupSearchDto, UpsertResourceGroupDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUrl = `${baseUrl}/api/resource-group`;

export const getAllResourceGroups = (
    request: Partial<ResourceGroupSearchDto>,
    source: CancelTokenSource): Promise<Array<ResourceGroupDto>> => {

  return axios
      .post(apiUrl, request, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getResourceGroupById = (
    id: number,
    source: CancelTokenSource): Promise<ResourceGroupDto> => {

  return axios
      .get(`${apiUrl}/${id}`, {cancelToken: source.token})
      .then((response) => response.data);
}

export const saveResourceGroup = (
    upsertResourceGroupDto: Partial<UpsertResourceGroupDto>,
    source: CancelTokenSource): Promise<ResourceGroupDto> => {

  return axios
      .post(`${apiUrl}/add`, upsertResourceGroupDto, {cancelToken: source.token})
      .then((response) => response.data);
};

export const editResourceGroup = (
    id: number, upsertResourceGroupDto: Partial<UpsertResourceGroupDto>,
    source: CancelTokenSource): Promise<ResourceGroupDto> => {

  return axios
      .put(`${apiUrl}/${id}`, upsertResourceGroupDto, {cancelToken: source.token})
      .then((response) => response.data);
};

export const deleteById = (
    id: number,
    source: CancelTokenSource): Promise<ResourceGroupDto> => {

  return axios
      .delete(`${apiUrl}/${id}`, {cancelToken: source.token})
      .then((response) => response.data);
};
